// import React, { useEffect, useRef, useState } from "react";
// import { BASE_URL } from "../../config/axios";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import axios from "axios";
// import { formatCurrencyIndian } from "../CustomFunctions";
// import { formattedDateLong } from "../Date";
// import { toast } from "react-toastify";
// import { fetchExistingLetterTemplate, numberToIndianWords } from "../CustomUtilities";
// import TemplateDisplayWrapper from "../DynamicBuilders/LetterDisplayComponents/TemplateDisplayWrapper";
// import { LetterPreview } from "../DynamicBuilders/LetterDisplayComponents/LetterPreview";

// const SavedSalarySlip = () => {
//   const location = useLocation();
//   const { i, slip_opener, monthh, yearr, prevUrl } = location.state;
//   const [salaryData, setSalaryData] = useState([])
//   const [subCompany, setSubCompany] = useState({});
//   const [letterTemplateData, setLetterTemplateData] = useState({});
//   const getSubCompanyId = sessionStorage.getItem('company_id');
//   const [buffer, setBuffering] = useState(false);
//   const [buffer1, setBuffering1] = useState(false);
//   const [isClient, setIsClient] = useState(false);
//   const ref = useRef();
//   useEffect(() => {
//     setIsClient(true);
//   }, []);

//   const getSlipData = async () => {
//     setBuffering1(true)
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/employeesalaryslipdata/${i.emp_code}/${yearr}/${monthh}/`);
//       setSalaryData(res.data)
//     } catch (err) {
//     }
//     finally {
//       setBuffering1(false)
//     }
//   };

//   useEffect(() => {
//     getSlipData();
//   }, []);

//   const monthNames = [
//     "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY",
//     "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
//   ];

//   console.log(i, "salary slip");


//   const monthName = monthNames[monthh - 1];
//   const loadLetterTemplate = async () => {
//     setBuffering(true)
//     try {
//       const { template, subcompany } = await fetchExistingLetterTemplate({
//         letterTemplateId: i?.saved_salary_data
//           ?.salary_data?.emp_data
//           ?.letter_template || null,
//         emp_code: i?.emp_code,
//         subcompanyId: i?.saved_salary_data
//           ?.salary_data?.emp_data?.division || i.sub_company_id
//       });

//       setLetterTemplateData(template);
//       if (subcompany) setSubCompany(subcompany);
//     } catch (err) {
//       toast.warning("Could not fetch letter template");
//     }
//     finally {
//       setBuffering(false)
//     }
//   };

//   useEffect(() => {

//     loadLetterTemplate();

//   }, [i?.emp_code, i?.saved_salary_data?.salary_data?.emp_data?.division, i?.saved_salary_data
//     ?.salary_data?.emp_data
//     ?.letter_template]);


//   const navigate = useNavigate()
//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split('/');
//   let backUrl = "/" + urlParts[3] + `/payrollmanagement`;

//   const filter_subCompany = location.state ? location.state?.filters?.subCompany : "";
//   const filter_status = location.state ? location.state?.filters?.active : "";
//   const filter_CostCenter = location.state ? location.state?.filters?.selectedCostCenter : "";
//   const filter_DataType = location.state ? location.state?.filters?.selectedDataType : "";
//   const filter_Department = location.state ? location.state?.filters?.selectedDep : "";
//   const filter_Designation = location.state ? location.state?.filters?.selectedDesi : "";
//   const filter_Name = location.state ? location.state?.filters?.selectedName : "";
//   const filter_Month = location.state ? location.state?.filters?.startMonth : "";
//   const filter_Year = location.state ? location.state?.filters?.startYear : "";


//   // let togglepayroll = 3;
//   let togglepayroll = 2;
//   const toggleslipmonth = monthh;
//   const toggleslipyear = yearr;
//   let toggleuser = 7;

//   if (slip_opener === "profile") {
//     // backUrl = "/" + urlParts[3] + `/userdetail`;
//     backUrl = prevUrl;
//     toggleuser = 7;
//   }
//   else if (slip_opener === "monthlyslip") {
//     backUrl = "/" + urlParts[3] + `/payrollmanagement`;
//     // togglepayroll = 3;
//     togglepayroll = 2;
//   }
//   else if (slip_opener === "empdetails") {
//     backUrl = "/" + urlParts[3] + `/payrollmanagement`;
//     togglepayroll = 4;
//   }


//   const backroute = () => {
//     navigate(backUrl, {
//       state: {
//         togglepayroll,
//         filter_subCompany,
//         filter_status,
//         filter_CostCenter,
//         filter_DataType,
//         filter_Department,
//         filter_Designation,
//         filter_Name,
//         filter_Month,
//         filter_Year,
//         toggleslipmonth, toggleslipyear, toggleuser
//       }
//     })
//   }


//   const contentData = (
//     <>
//       <div className='printSlip-header-left-text  font-size-heading' style={{ padding: '2px 0px', marginBottom: '20px' }}>
//         SALARY SLIP FOR THE MONTH OF {monthName} {yearr}
//       </div>
//       <div className='salaryslip-header-second' style={{ margin: '0px' }}>
//         <div className='salaryslip-header-second-section1'>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>NAME</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>FATHER / HUSBAND</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DATE OF JOINING</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DEPARTMENT</div>
//         </div>
//         <div className='salaryslip-header-second-section2'>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading '>{salaryData.salary_data?.name ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.father_name ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.joining_date ? formattedDateLong(salaryData.salary_data?.user_details?.joining_date) : "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.department_name ?? "-"}</div>
//         </div>
//         <div className='salaryslip-header-second-section3'>
//         </div>
//         <div className='salaryslip-header-secondsection4'>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>CODE</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>BANK</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>ACCOUNT NO.</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>IFSC NO.</div>
//           {/* <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>UAN NO.</div> */}
//         </div>
//         <div className='salaryslip-header-second-section5'>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.emp_code ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.bank_name ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.account_number ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.ifsc_code ?? "-"}</div>
//           {/* <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details.branch_address}</div> */}
//         </div>
//       </div>
//       <div className='salaryslip-hr' style={{ marginTop: '20px' }}></div>
//       <div className='salaryslip-header-third' style={{ margin: '20px 0px', padding: '0px' }}>
//         <div className='salaryslip-header-third-section1'>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL DAYS</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL LEAVES</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL ABSENT</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WORKING DAYS</div>
//         </div>
//         <div className='salaryslip-header-third-section2'>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_days}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.leave}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.absent}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_paid_days}</div>


//         </div>
//         <div className='salaryslip-header-third-section3'>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WEEKLY OFF</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>LEAVE WITHOUT PAY</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>HOLIDAY</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>NET PAID DAYS</div>

//         </div>
//         <div className='salaryslip-header-third-section4'>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.weeklyoff}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.unpaidleave}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.holiday}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_paid_days}</div>
//         </div>
//       </div>
//       {/* <div className='salaryslip-hr' ></div> */}
//       <div className='salaryslip-body'>
//         <table className='nested-table-modern nested-table-outer' style={{ marginTop: '0px', marginBottom: '0px' }}>
//           <thead>
//             <tr className='slaryslip-head'>
//               {/* <th >S. No.</th> */}
//               <th className="align-center" style={{ width: "260px", padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }}>SALARY COMPONENT</th>
//               <th className="align-center" style={{ padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }} >STANDARD</th>
//               <th className="align-center" style={{ padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }}>AMOUNT</th>
//             </tr>
//           </thead>
//           <tbody>
//             {
//               salaryData.salary_data?.deduction_details
//                 ?.filter((j) => !isNaN(j.standard_amount) && !isNaN(j.actual_amount) && j.salaryslip !== false)
//                 .sort((a, b) => a.sorting_var - b.sorting_var)
//                 .map((j, index) => {
//                   const isSpecialRow = j.salary_type === "total" || j.salary_type === "difference";
//                   return (
//                     <tr key={index} className={isSpecialRow ? "special-row" : "gray-row"}>
//                       <td>{j.name}</td>
//                       <td className="align-right">{formatCurrencyIndian(j.standard_amount)}</td>
//                       <td className="align-right">{formatCurrencyIndian(j.actual_amount)}</td>
//                     </tr>
//                   );
//                 })
//             }
//           </tbody>
//         </table>
//         <table className='nested-table-modern ' style={{ marginTop: '20px', marginBottom: '0px' }}>
//           <tbody>
//             <tr className="salary-total-row">
//               <td colSpan={1}>SALARY PAY</td>
//               <td colSpan={3}>
//                 {
//                   formatCurrencyIndian(
//                     salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
//                   )
//                 }
//               </td>
//             </tr>
//             {/* <tr className="salary-total-row in-words-row">
//                   <td colSpan={1}>IN WORDS</td>
//                   <td colSpan={3}>
//                     {
//                       numberToWords.toWords(
//                         i.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
//                       ).toUpperCase()
//                     }
//                   </td>
//                 </tr> */}
//             <tr className="salary-total-row in-words-row">
//               <td colSpan={1}>IN WORDS</td>
//               <td colSpan={3}>
//                 {/* {
//                         (() => {
//                           const amountStr = i.deduction_details.find((j) => j.final_salary)?.actual_amount;
//                           const amount = Number(amountStr.replace(/,/g, ''));
//                           if (!isNaN(amount) && isFinite(amount)) {
//                             return numberToIndianWords(5000000).toUpperCase() + " ONLY";
//                           } else {
//                             return "---";
//                           }
//                         })()
//                       } */}
//                 {
//                   (() => {
//                     const detail = Array.isArray(salaryData?.salary_data?.deduction_details)
//                       ? salaryData?.salary_data?.deduction_details.find((j) => j?.final_salary)
//                       : null;

//                     const amountStr = detail?.actual_amount;

//                     if (typeof amountStr === 'number' && isFinite(amountStr)) {
//                       return numberToIndianWords(amountStr).toUpperCase() || '-';
//                     } else if (typeof amountStr === 'string') {
//                       const amount = Number(amountStr.replace(/,/g, ''));
//                       if (!isNaN(amount) && isFinite(amount)) {
//                         return numberToIndianWords(amount).toUpperCase() || '-';
//                       }
//                     }

//                     return "---";
//                   })()
//                 }

//               </td>
//             </tr>


//           </tbody>
//         </table>
//       </div>
//     </>
//   )


//   return (
//     <>
//       <TemplateDisplayWrapper
//         onBack={backroute}
//         ref={ref}
//         downloadEnable={false}
//       >
//       </TemplateDisplayWrapper >
//       <LetterPreview
//         letterTemplateData={letterTemplateData}
//         subCompany={subCompany}
//         buffer1={buffer}
//         buffer2={buffer1}
//         ref={ref}
//         // fontSize={16}
//         lineHeight={1.5}
//         showDefaultSignText={true}
//       >
//         {contentData}
//       </LetterPreview>
//     </>


//   )
// }

// export default SavedSalarySlip




import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import { BASE_URL, FRONTEND_URL } from "../../config/axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import numberToWords from 'number-to-words';
import { formatCurrencyIndian } from "../CustomFunctions";
import { formattedDateLong } from "../Date";
import { Printer } from "../AllSvg";
import { toast } from "react-toastify";
import { fetchExistingLetterTemplate, numberToIndianWords } from "../CustomUtilities";

const DataSalarySlip = React.forwardRef((props, ref) => {
  let { month, year, id } = useParams();
  const location = useLocation();
  const { i, monthh, yearr } = location.state;
  const [salaryData, setSalaryData] = useState([])
  const [subCompany, setSubCompany] = useState({});
  const [letterTemplateData, setLetterTemplateData] = useState({});
  const getSubCompanyId = sessionStorage.getItem('company_id')

  const getSlipData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employeesalaryslipdata/${i.emp_code}/${yearr}/${monthh}/`);
      setSalaryData(res.data)

    } catch (err) {
    }
  };

  useEffect(() => {
    getSlipData();
  }, []);
  console.log(salaryData, "Salarydata");

  const monthNames = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY",
    "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
  ];

  const monthName = monthNames[monthh - 1];
  const loadLetterTemplate = async () => {

    try {
      // const { template, subcompany } = await fetchExistingLetterTemplate({
      //   letterTemplateId: i?.emp_data?.letter_template,
      //   emp_code: i?.emp_code,
      //   subcompanyId: getSubCompanyId
      // });

      const { template, subcompany } = await fetchExistingLetterTemplate({
        letterTemplateId: i?.saved_salary_data
          ?.salary_data?.emp_data
          ?.letter_template || null,
        emp_code: i?.emp_code,
        subcompanyId: i?.saved_salary_data
          ?.salary_data?.emp_data?.division || i?.sub_company_id
          || i?.sub_company
        // subcompanyId: i?.saved_salary_data
        //   ?.salary_data?.emp_data?.division || i.sub_company_id
      });


      setLetterTemplateData(template);
      if (subcompany) setSubCompany(subcompany);
    } catch (err) {
      toast.warning("Could not fetch letter template");
    }
  };

  // useEffect(() => {

  //   loadLetterTemplate();

  // }, [i?.emp_code, getSubCompanyId, i?.emp_data?.letter_template]);

  useEffect(() => {

    loadLetterTemplate();

  }, [
    // i?.emp_code, i?.saved_salary_data?.salary_data?.emp_data?.division, i?.saved_salary_data
    // ?.salary_data?.emp_data
    // ?.letter_template
    i?.emp_code,
    i?.saved_salary_data?.salary_data?.emp_data?.division,
    i?.sub_company_id,
    i?.sub_company,
    i?.saved_salary_data?.salary_data?.emp_data?.letter_template
  ]);

  return (
    // <>
    <div ref={ref}
      style={{
        // ...getPaperDimensions(letterTemplateData?.page_size || "A4"),

        width: '210mm',
        position: "relative",
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        // className='salaryslip'
        className='letterslip letterslip-outer'
      >
        {/* <div className='salaryslip-header'>
          <div className='salaryslip-header-left'>
            <img src={Logo} alt='logo' className='salaryslip-logo' />
            <div className='salaryslip-header-left-text  font-size-heading'>
              SALARY SLIP FOR THE MONTH OF {monthName} {yearr}
            </div>
          </div>
          <div className='salaryslip-header-right'>
            <div className='salaryslip-header-right-top  font-weight600   font-size-heading'>
              Civilmantra infracon limited
            </div>
            <div className='salaryslip-header-right-bottom  font-weight400  font-size-subheading'>
              3rd Floor, Tower 3A,<br /> DLF Corporate Greens, Sector 74A,<br /> Gurugram, Haryana 122004 <br /> hr@civilmantra.com
            </div>
          </div>
        </div> */}

        {(letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email || letterTemplateData?.header_full_image)
          ?
          (
            letterTemplateData?.header_full_image ? (
              <div className='salaryslip-header'
                style={{
                  paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                  paddingRight: `${letterTemplateData?.header_right_gap}px`,
                  paddingTop: `${letterTemplateData?.header_top_gap}px`,
                  paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                }}
              >
                <img src={`${letterTemplateData?.header_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
              </div>
            )
              :
              (
                (letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email) &&
                (
                  <>
                    <div className='salaryslip-header'
                      style={{
                        paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                        paddingRight: `${letterTemplateData?.header_right_gap}px`,
                        paddingTop: `${letterTemplateData?.header_top_gap}px`,
                        paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                      }}
                    >
                      <div className='salaryslip-header-left'>
                        {!letterTemplateData?.header_full_image &&
                          letterTemplateData?.header_logo ? (
                          <img src={`${letterTemplateData?.header_logo}`} alt='logo' className='salaryslip-logo' />
                        ) : ('')
                        }

                      </div>
                      <div className='salaryslip-header-right text-end'>

                        {
                          letterTemplateData?.header_company_name ? (
                            <div className={`salaryslip-header-right-top-red font-weight600 font-size-heading`} style={{ color: letterTemplateData?.header_primary_colour || 'black' }}>
                              {letterTemplateData?.header_company_name}
                            </div>
                          ) : (
                            ''
                          )}

                        {
                          (letterTemplateData?.header_Address || letterTemplateData?.header_email) && (
                            <>
                              <div style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400  font-size-subheading letter-address'
                                dangerouslySetInnerHTML={{ __html: letterTemplateData?.header_Address }}
                              >
                              </div>
                              <span className="letter-address" style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }}> {letterTemplateData?.header_email} </span>
                            </>
                          )

                        }
                      </div>
                    </div>
                    {!letterTemplateData?.header_full_image && (<div className='salaryslip-hr mb-2'></div>)}

                  </>
                )
              )
          ) :
          (
            <>
              <div className='salaryslip-header ' style={{ padding: '10px' }}>
                {subCompany?.company_logo && (
                  <div className='salaryslip-header-left'>
                    <img src={subCompany?.company_logo} alt={subCompany?.title} className='salaryslip-logo' />
                  </div>
                )}
                <div className='salaryslip-header-right'>
                  {subCompany?.company_name && (
                    <div className='printSlip-header-right-top  font-weight600   font-size-heading' style={{ marginBottom: '5px', textAlign: 'end' }}>
                      {subCompany?.company_name}
                    </div>
                  )}
                  <div className='salaryslip-header-right-bottom  font-weight400  font-size-subheading'>
                    {subCompany?.company_address && (
                      <div className='slip-top-right-content' style={{ textAlign: 'right' }} dangerouslySetInnerHTML={{ __html: subCompany?.company_address }} />
                    )}
                  </div>
                </div>
              </div>
              <div className='salaryslip-hr'></div>
            </>
          )
        }

        <div className='content-container'
          style={{
            paddingLeft: !letterTemplateData?.id ? `${letterTemplateData?.content_left_gap}px` : '20px',
            paddingRight: !letterTemplateData?.id ? `${letterTemplateData?.content_right_gap}px` : '20px',
            paddingTop: !letterTemplateData?.id && '20px',
            paddingBottom: !letterTemplateData?.id && '20px',
            overflow: 'hidden',
            wordWrap: "break-word",
            // minHeight: '165vh',
            // height: 'auto'
          }}>
          <div className='printSlip-header-left-text  font-size-heading' style={{ padding: '0px 0px', margin: '20px' }}>
            SALARY SLIP FOR THE MONTH OF {monthName} {yearr}
          </div>
          {/* <div className='printSlip-hr hr-line'></div> */}
          <div className='salaryslip-header-second'>
            <div className='salaryslip-header-second-section1'>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>NAME</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>FATHER / HUSBAND</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DATE OF JOINING</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DEPARTMENT</div>
            </div>
            <div className='salaryslip-header-second-section2'>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.name ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.father_name ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.joining_date ? formattedDateLong(salaryData.salary_data?.user_details?.joining_date) : "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.user_details?.department_name ?? "-"}</div>
            </div>
            <div className='salaryslip-header-second-section3'>
            </div>
            <div className='salaryslip-header-secondsection4'>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>CODE</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>BANK</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>ACCOUNT NO.</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>IFSC NO.</div>
              {/* <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>UAN NO.</div> */}
            </div>
            <div className='salaryslip-header-second-section5'>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.emp_code ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.bank_name ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.account_number ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details?.ifsc_code ?? "-"}</div>
              {/* <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{salaryData.salary_data?.bank_details.branch_address}</div> */}
            </div>
          </div>
          <div className='salaryslip-hr'></div>
          <div className='salaryslip-header-third'>
            <div className='salaryslip-header-third-section1'>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL DAYS</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL LEAVES</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL ABSENT</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WORKING DAYS</div>
            </div>
            <div className='salaryslip-header-third-section2'>
              {/* <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_days}</div> */}
              <div className='salaryslip-heading-blue font-weight500'>
                {monthName === 'MAY' ? 24 : salaryData.salary_data?.total_days}
              </div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.leave}</div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.absent}</div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_paid_days}</div>

            </div>
            <div className='salaryslip-header-third-section3'>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WEEKLY OFF</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>LEAVE WITHOUT PAY</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>HOLIDAY</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>NET PAID DAYS</div>

            </div>
            <div className='salaryslip-header-third-section4'>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.weeklyoff}</div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.unpaidleave}</div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.attendance_summary?.holiday}</div>
              <div className='salaryslip-heading-blue font-weight500'>{salaryData.salary_data?.total_paid_days}</div>
            </div>
          </div>
          <div className='salaryslip-hr'></div>
          <div className='salaryslip-body'>
            <table className='nested-table-modern nested-table-outer'>
              <thead>
                <tr className='slaryslip-head'>
                  {/* <th >S. No.</th> */}
                  <th className="align-center" style={{ width: "260px", padding: "0px 5px" }}>SALARY COMPONENT</th>
                  <th className="align-center" >STANDARD</th>
                  <th className="align-center" >AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {
                  salaryData.salary_data?.deduction_details
                    ?.filter((j) => !isNaN(j.standard_amount) && !isNaN(j.actual_amount) && j.salaryslip !== false)
                    .sort((a, b) => a.sorting_var - b.sorting_var)
                    .map((j, index) => {
                      const isSpecialRow = j.salary_type === "total" || j.salary_type === "difference";
                      return (
                        <tr key={index} className={isSpecialRow ? "special-row" : "gray-row"}>
                          <td>{j.name}</td>
                          <td className="align-right">{formatCurrencyIndian(j.standard_amount)}</td>
                          <td className="align-right">{formatCurrencyIndian(j.actual_amount)}</td>
                        </tr>
                      );
                    })
                }
              </tbody>
            </table>
            <table className='nested-table-modern'>
              <tbody>
                <tr className="salary-total-row">
                  <td>SALARY PAY</td>
                  <td>
                    {
                      // formatCurrencyIndian(
                      //   salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                      // )
                      formatCurrencyIndian(
                        Math.round(salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0)
                      )
                    }
                  </td>
                </tr>
                <tr className="salary-total-row in-words-row">
                  <td>IN WORDS</td>
                  <td>
                    {/* {
                      // numberToWords.toWords(
                      //   salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                      // ).toUpperCase()
                      numberToIndianWords.toWords(
                        salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                      ).toUpperCase()
                    } */}
                    {/* {
                      (() => {
                        const amountStr = i.deduction_details.find((j) => j.final_salary)?.actual_amount;
                        const amount = Number(amountStr.replace(/,/g, ''));
                        if (!isNaN(amount) && isFinite(amount)) {
                          return numberToIndianWords(salaryData.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0).toUpperCase() + " ONLY";
                        } else {
                          return "---";
                        }
                      })()
                    } */}
                    {
                      (() => {
                        const detail = Array.isArray(salaryData?.salary_data?.deduction_details)
                          ? salaryData?.salary_data?.deduction_details.find((j) => j?.final_salary)
                          : null;

                        const amountStr = detail?.actual_amount;

                        // if (typeof amountStr === 'number' && isFinite(amountStr)) {
                        //   return numberToIndianWords(amountStr).toUpperCase() || '-';
                        // } else if (typeof amountStr === 'string') {
                        //   const amount = Number(amountStr.replace(/,/g, ''));
                        //   if (!isNaN(amount) && isFinite(amount)) {
                        //     return numberToIndianWords(amount).toUpperCase() || '-';
                        //   }
                        // }

                        if (typeof amountStr === 'number' && isFinite(amountStr)) {
                          return numberToIndianWords(Math.round(amountStr)).toUpperCase() || '-';
                        } else if (typeof amountStr === 'string') {
                          const amount = Number(amountStr.replace(/,/g, ''));
                          if (!isNaN(amount) && isFinite(amount)) {
                            return numberToIndianWords(Math.round(amount)).toUpperCase() || '-';
                          }
                        }

                        return "---";
                      })()
                    }

                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <h6 style={{ fontSize: '10px' }}><b>*This is Software generated Salary Slip no signature required*</b></h6>
          </div>
        </div>
        {/* {!letterTemplateData?.footer_full_image && (<div className='salaryslip-hr'></div>)} */}


        {
          letterTemplateData?.footer_full_image && (
            <div className='salaryslip-header salaryslip-footer'
              style={{
                paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
                paddingRight: `${letterTemplateData?.footer_right_gap}px`,
                paddingTop: `${letterTemplateData?.footer_top_gap}px`,
                paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,

                // bottom: '0',
                position: 'absolute',

                width: '-webkit-fill-available',
                backgroundColor: 'white'
              }}
            >
              <img src={`${letterTemplateData?.footer_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
            </div>
          )
        }


        {
          (letterTemplateData?.footer_logo || letterTemplateData?.footer_company_name || letterTemplateData?.footer_Address || letterTemplateData?.footer_email) &&

          <div className='salaryslip-header salaryslip-footer'
            style={{
              paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
              paddingRight: `${letterTemplateData?.footer_right_gap}px`,
              paddingTop: `${letterTemplateData?.footer_top_gap}px`,
              paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,
              position: 'absolute',
              width: '-webkit-fill-available',
              backgroundColor: 'white'
            }}
          >
            <div className='salaryslip-header-left'>
              {!letterTemplateData?.footer_full_image && letterTemplateData?.footer_logo ? (
                <img src={letterTemplateData?.footer_logo} alt='logo' className='salaryslip-logo' />
              ) : (
                <div></div>
              )}
            </div>

            <div className='salaryslip-header-right text-end'>
              {letterTemplateData?.footer_company_name && (
                <div className='salaryslip-header-right-top-red font-weight600 font-size-heading' style={{ color: letterTemplateData?.footer_primary_colour || 'black' }}>
                  {letterTemplateData?.footer_company_name}
                </div>
              )}

              {(letterTemplateData?.footer_Address || letterTemplateData?.footer_email) && (
                <>
                  <div style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400 font-size-subheading letter-address' dangerouslySetInnerHTML={{ __html: letterTemplateData?.footer_Address }}>

                  </div>
                  <span className="letter-address" style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }}> {letterTemplateData?.footer_email}</span>
                </>
              )}
            </div>
          </div>
        }

      </div>
      {letterTemplateData?.bg_image ? (
        <div
          className="aimantra-bg-letter"
          style={{

            backgroundImage: `url(${letterTemplateData?.bg_image})`,
            backgroundSize: `${letterTemplateData?.bg_size}%`,
            backgroundRepeat: 'no-repeat',
            opacity: `${letterTemplateData?.bg_opacity || 100}%`,
            transform: letterTemplateData.bg_angle
              ? `rotate(${letterTemplateData.bg_angle}deg)`
              : "none",
          }}
        ></div>
      )
        :
        (
          <div
            className="aimantra-bg-letter"
            style={{ backgroundImage: `url(${subCompany?.company_logo})` }}
          >
          </div>
        )
      }
    </div>

  )
});
const PrintDynamicSalarySlipData = () => {
  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  let backUrl = "/" + urlParts[3] + `/payrollmanagement`;
  const location = useLocation();

  const filter_subCompany = location.state ? location.state?.filters?.subCompany : "";
  const filter_status = location.state ? location.state?.filters?.active : "";
  const filter_CostCenter = location.state ? location.state?.filters?.selectedCostCenter : "";
  const filter_DataType = location.state ? location.state?.filters?.selectedDataType : "";
  const filter_Department = location.state ? location.state?.filters?.selectedDep : "";
  const filter_Designation = location.state ? location.state?.filters?.selectedDesi : "";
  const filter_Name = location.state ? location.state?.filters?.selectedName : "";
  const filter_Month = location.state ? location.state?.filters?.startMonth : "";
  const filter_Year = location.state ? location.state?.filters?.startYear : "";


  const { slip_opener, monthh, yearr, prevUrl, filters } = location.state;
  // let togglepayroll = 3;
  let togglepayroll = 2;
  const toggleslipmonth = monthh;
  const toggleslipyear = yearr;
  let toggleuser = 7;

  if (slip_opener === "profile") {
    console.log("A")
    // backUrl = "/" + urlParts[3] + `/userdetail`;
    backUrl = prevUrl;
    toggleuser = 7;
  }
  else if (slip_opener === "monthlyslip") {
    console.log("B")
    backUrl = "/" + urlParts[3] + `/payrollmanagement`;
    // togglepayroll = 3;
    togglepayroll = 2;
  }
  else if (slip_opener === "empdetails") {
    console.log("C")
    backUrl = "/" + urlParts[3] + `/payrollmanagement`;
    togglepayroll = 4;
  }


  const backroute = (togglepayroll, toggleuser) => {
    navigate(backUrl, {
      state: {
        togglepayroll, toggleslipmonth, toggleslipyear, toggleuser,
        filter_subCompany,
        filter_status,
        filter_CostCenter,
        filter_DataType,
        filter_Department,
        filter_Designation,
        filter_Name,
        filter_Month,
        filter_Year,
        filters: filters,
      }
    })
  }

  return (

    <div>
      <div className='flex-column flex-center  slip-container'>
        <div className='printSlip-width flex-row justify-evenly button-margin'>
          <button className="model-button model-button-black font-weight500   " onClick={(e) => { backroute(togglepayroll, toggleuser) }}>Back</button>
          <ReactToPrint
            bodyClass="print-agreement"
            content={() => ref.current}
            trigger={() => (
              <button className="model-button model-button-black">
                <Printer /> Print
              </button>
            )}
          />
        </div>

        <DataSalarySlip ref={ref} />
      </div>
    </div >
  );
};
export default PrintDynamicSalarySlipData

